let serviceRequestNumber = 0;
export default function getRequestNumber(): number {
    return serviceRequestNumber++;
}
